import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '@auth/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
})
export class NavbarComponent {
  readonly authService = inject(AuthService);

  readonly user = this.authService.user;
  readonly authStatus = this.authService.authStatus;

  // Módulos
  readonly hasCotizacionesModule = this.authService.hasCotizacionesModule;
  readonly hasCobrosModule = this.authService.hasCobrosModule;
  readonly hasPagosModule = this.authService.hasPagosModule;
  readonly hasEstadisticasModule = this.authService.hasEstadisticasModule;
  readonly hasReporteModule = this.authService.hasReporteModule;
  readonly hasPolizasModule = this.authService.hasPolizasModule;
  readonly hasReclamacionesModule = this.authService.hasReclamacionesModule;
  readonly hasConsultaModule = this.authService.hasConsultaModule;
  readonly hasAdministrativoModule = this.authService.hasAdministrativoModule;
  readonly hasMantenimientoModule = this.authService.hasMantenimientoModule;
  readonly hasEmisionModule = this.authService.hasEmisionModule;

  // Permisos Específicos
  readonly canCotizarAuto = this.authService.canCotizarAuto;
  readonly canCotizarSmi = this.authService.canCotizarSmi;
  readonly canCotizarArmaloTu = this.authService.canCotizarArmaloTu;
  readonly canDescuentoArmaloTu = this.authService.canDescuentoArmaloTu;
  readonly canEmprendeSeguro = this.authService.canEmprendeSeguro;
  readonly canHogarSeguro = this.authService.canHogarSeguro;

  readonly canCreditCardPayment = this.authService.canCreditCardPayment;
  readonly canReprintCardReceipts = this.authService.canReprintCardReceipts;

  readonly canViewStatisticsReports = this.authService.canViewStatisticsReports;
  readonly canViewBondGrowth = this.authService.canViewBondGrowth;

  readonly canViewLossRatio = this.authService.canViewLossRatio;

  readonly canViewPoliciesReports = this.authService.canViewPoliciesReports;

  readonly canViewMyClaims = this.authService.canViewMyClaims;

  readonly canViewClients = this.authService.canViewClients;

  readonly canViewInsureds = this.authService.canViewInsureds;

  readonly canSafeSurgery = this.authService.canSafeSurgery;
  readonly canViewMyUsers = this.authService.canViewMyUsers;

  onLogout(): void {
    this.authService.logout();
  }

  get smiUrl(): string {
    const cotizadorUrl = (environment as any).cotizadorUrl;
    const mode = this.authService.user()?.isInternal ? 'aad' : 'b2c';
    return `${cotizadorUrl}/quote-smi-list?mode=${mode}`;
  }

  get personasUrl(): string {
    const cotizadorUrl = (environment as any).cotizadorUrl;
    const mode = this.authService.user()?.isInternal ? 'aad' : 'b2c';
    return `${cotizadorUrl}/personal-insurance-options?mode=${mode}`;
  }

  get riesgosUrl(): string {
    const cotizadorUrl = (environment as any).cotizadorUrl;
    const mode = this.authService.user()?.isInternal ? 'aad' : 'b2c';
    return `${cotizadorUrl}/risk-insurance-options?mode=${mode}`;
  }

  closeDrawer(): void {
    const drawer = document.getElementById('drawer-toggle') as HTMLInputElement | null;
    if (drawer) {
      drawer.checked = false;
    }
  }
}
